import { useMemo } from 'react'

import { useLocale } from '../../hooks/use-locale'
import { DateFormatter } from '../../utils'

const useDateFormatter = () => {
  const { locale } = useLocale()
  const formatter = useMemo(() => new DateFormatter(locale), [locale])
  return formatter
}

export default useDateFormatter
